import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import { layout } from "../../../_App/Redux/Slices/Caisse/CaisseSlice";
import {
  Currentpage,
  ListOnlineOrders,
  ListOrders,
  TotalNet,
  TotalPages,
  findFiltreSoldProductsApi,
  findOrdersFiltreApi,
  resetSelectedOrder,
  selectOrder,
  updateOrderApi,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
  selectUser,
  societeId,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import { formatdate, statusList } from "../../../_App/Helpers/helpers";
import { useTranslation } from "react-i18next";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { findPaymentsByOrderApi } from "../../../_App/Redux/Slices/payments/PaymentSlice";
import {
  addClient,
  addToPanier,
  confirmOrder,
  Panier,
  ReservationToPanier,
  resetPanier,
  SelectedOrders,
  selectedRefundedOrders,
  setClientRemise,
  setNetPriceArticle,
  setOperationType,
  setOrderid,
} from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import { useNavigate } from "react-router-dom";
import OnlineOrderInvoice from "./OnlineOrderInvoice";
import { OrderType } from "../../../_App/Types/Entites/Orders/OrderType";
import OrderStatusPopUp from "./OrderStatusPopUp";
import {
  confirmReservationApi,
  findReservationByorderId,
} from "../../../_App/Redux/Slices/Reservation/ReservationSlice";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { UserDataType } from "../../../_App/Types/Forms/UserDataType";
import Select, { MultiValue } from "react-select";
import {
  findUserByOrganisationApi,
  ListUsers,
} from "../../../_App/Redux/Slices/users/userSlice";
import { Spinner } from "react-bootstrap";
import Pagination from "../../../Shared/Pagination/Pagination";
import PaginationLayout from "../../../_Layouts/Pagination/PaginationLayout";
import Swal from "sweetalert2";
import {
  findTicketsByOrganisationApi,
  initialeListTicket,
  ordersTickets,
} from "../../../_App/Redux/Slices/tickets/TicketSlice";
import TicketAvance from "../TicketDeCaisse/TicketAvance";
import TicketType from "../../../_App/Types/Entites/TicketType";
import {
  findSocieteLivraison,
  SocieteLivraison,
} from "../../../_App/Redux/Slices/societe/societeSlice";
import { findArticleRefParentApi } from "../../../_App/Redux/Slices/article/articleSlice";
import ArticleListReference from "../../../_Layouts/RightBar/RightBar/cart/ArticleListReference";

const OrdersListOnline = () => {
  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const parametrage = useAppSelector(parametrageCaisse);
  const navigate = useNavigate();
  const selectedOrganisation = useAppSelector(SelectedOrganisation);
  const user = useAppSelector(selectUser);
  const cart = useAppSelector(Panier);
  const isOnlineSale = user?.role_id?.libelle === "onlineSale";
  const [includesRemise, setincludesRemise] = useState(false);
  const Orders = useAppSelector(isOnlineSale ? ListOnlineOrders : ListOrders);

  const currentpage = useAppSelector(Currentpage);
  const totalPages = useAppSelector(TotalPages);
  const totalNet = useAppSelector(TotalNet);

  const listusers = useAppSelector(ListUsers);
  const [index, setindex] = useState(1);
  const [loader, setloader] = useState(false);
  //// gestion avance
  const [ticketId, setTicketId] = useState<string | null>(null);
  const [showModalTicketAvance, setShowModalTicketAvance] = useState(false);
  const [Reservation, setReservation] = useState();
  /*****************filtre*************** */
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  interface FiltreInterface {
    organisation: any;
    dateDebut: any;
    dateFin: any;
    listcaissiers: UserDataType[];
    listvendeur: UserDataType[];
    status: any;
    numOrder: any;
    index: any;
    keyword: any;
    includesRemise: boolean;
  }

  const [filtre, setFiltre] = useState<FiltreInterface>({
    organisation: currentOrganisation,
    dateFin: formatdate(today),
    dateDebut: formatdate(today),
    listcaissiers: [],
    listvendeur: [],
    status: "Tout",
    numOrder: null,
    index: 1,
    keyword: "",
    includesRemise: includesRemise,
  });
  const filtreStore: any = localStorage.getItem("filtreVente");

  useEffect(() => {
    if (filtreStore) {
      const jsonfiltreStore: FiltreInterface = JSON.parse(filtreStore);
      setFiltre(jsonfiltreStore);
    }
  }, [filtreStore]);

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSelectChangeUsers = (selectedUsers: any) => {
    const copie = { ...filtre };
    copie.listcaissiers = selectedUsers.map((item: any) => item.value);
    setFiltre(copie);
  };
  const handleSelectChangeVendeur = (selectedUsers: any) => {
    const copie = { ...filtre };
    copie.listvendeur = selectedUsers.map((item: any) => item.value);
    setFiltre(copie);
  };
  const handleSelectMultipleOrders = async () => {
    if (!selectedOrders?.length) return;
    if (selectedOrders?.length > 0 && refundedOrders?.length > 0) {
      console.log("selectedOrders", selectedOrder);
      await dispatch(
        SelectedOrders({
          orders: selectedOrders,
          // livraison: steLivraison.frais_livraison,
        }),
      );
      await dispatch(
        selectedRefundedOrders({
          orders: refundedOrders,
          // frais_livraison: steLivraison.frais_livraison,
        }),
      );
      await dispatch(setOperationType({ type: "Pay", refunded: [] }));
      window.location.href = "/caisse";
    } else {
      const result = await Swal.fire({
        title: "Inclure les commandes remboursées ?",
        text: "Souhaitez-vous inclure les commandes remboursées dans cette opération ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non, seulement les non payées",
      });

      if (result.isConfirmed) {
        setSelectingRefundOnly(true);
      } else {
        await dispatch(
          SelectedOrders({
            orders: selectedOrders,
            // livraison: steLivraison.frais_livraison,
          }),
        );
        await dispatch(setOperationType({ type: "Pay", refunded: [] }));

        window.location.href = "/caisse";
      }
    }
  };
  const handleSelectOrder = async (order: any) => {
    // navigate("/caisse");
    localStorage.setItem("filtreVente", JSON.stringify(filtre));

    if (
      order.status === "Payée" ||
      order.status === "Annulée" ||
      order.status === "Retour" ||
      // order.status === "En cours" ||
      // order.status === "Nouvelle" ||
      // order.status === "Pre-confirmée" ||
      order.status === "En livraison"
    ) {
      dispatch(resetPanier(parametrage.timbreTicket || 0));

      navigate(`/PaidOrder/${order._id}`);
    } else if (order.status === "Avoir" || order.status === "Echange") {
      Swal.fire({
        title: `Commande numéro ${order.order_number}`,
        text: ` La demande est ${order.status}`,
      });
    } else if (order.status === "Pre-confirmée") {
      await dispatch(addClient(order?.client_id));
      await dispatch(setOrderid(order._id));
      order.items.forEach(async (item: any) => {
        await dispatch(
          addToPanier({
            article: item.article,
            quantity: item.quantity, // Negative quantity for returns
            outOFStock: item.outOFStock,
            sold_quantity: item.sold_quantity,
            prix_unitaire: item.prix_unitaire, // Negative price for returns
            prix_total: item.prix_unitaire * item.quantity, // Total price negative
            paid_quantity: 0,
            remise: item.remise || 0,
            remisepropsition: item.remisepropsition,
            remiseClient: 0,
            type:
              order.status === "demande Valide"
                ? "defaut"
                : item?.type
                ? item.type
                : "fils",
            note: item?.note,
            prixNet: -(
              item.prix_unitaire *
              item.Qteretour *
              (item.remise / 100)
            ), // Negative net price
          }),
        );
      });
      dispatch(confirmOrder());

      if (isOnlineSale) {
        await dispatch(selectOrder({ order_id: order._id, orderdata: order }));
        navigate(`/caisse/${order._id}`);
      } else {
        navigate("/caisse");
      }
    } else {
      await dispatch(selectOrder({ order_id: order._id, orderdata: order }));
      await dispatch(addClient(order?.client_id));

      navigate(`/caisse/${order._id}`);
    }
  };

  useEffect(() => {
    getListOrder("");
  }, [index]);
  function formatDateAndTime(timestamp: Date) {
    const dateObject = new Date(timestamp);

    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");

    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    const seconds = dateObject.getSeconds().toString().padStart(2, "0");

    const formattedDateAndTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateAndTime;
  }

  const [stateShow, setStateShow] = useState(false);
  const [show, setShow] = useState("");

  const open = () => {
    if (show !== "show") {
      setShow("show");
      setStateShow(true);
    } else {
      setShow("");
      setStateShow(false);
    }
  };
  const societe_id = useAppSelector(societeId);
  useEffect(() => {
    if (currentOrganisation) {
      dispatch(findUserByOrganisationApi(currentOrganisation));
      dispatch(findTicketsByOrganisationApi(currentOrganisation));
    }
    if (societe_id) dispatch(findSocieteLivraison(societe_id));
  }, [currentOrganisation]);

  const delivery_companies = useAppSelector(SocieteLivraison);
  const getListOrder = async (keyword: any) => {
    setFiltre((prevFiltre) => {
      const updatedFiltre = {
        ...prevFiltre,
        index: index,
        keyword: keyword,
        type: isOnlineSale ? "online" : "caisse",
      };

      dispatch(findOrdersFiltreApi(updatedFiltre));
      dispatch(findFiltreSoldProductsApi(updatedFiltre));
      return updatedFiltre;
    });
  };

  const { t } = useTranslation();
  const [facture, setFacture] = useState(false);
  const [orderId, setOrderId] = useState<String | undefined>(undefined);
  const [ticket, setTicket] = useState<String | undefined>(undefined);

  useEffect(() => {
    if (orderId) {
      setFacture(true);
    }
  }, [orderId]);
  const handleOpenTicket = (order_id: string, ticket: any) => {
    setOrderId(order_id); // Trigger the state change
    setTicket(ticket);
  };
  const handleCloseModal = () => {
    setFacture(false); // Close the modal
    setOrderId(""); // Optionally clear the orderId or reset it
  };
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({ id: "", status: "" });
  // const handleStatusClick = (order: OrderType) => {
  //   setSelectedOrder({ id: order._id, status: order.status });
  //   setShowStatusModal(true);
  // };

  // Update selected status
  const handleStatusChange = (newStatus: any) => {
    setSelectedOrder((prev) => ({ ...prev, status: newStatus }));
  };

  const UsersOptions = listusers?.map((option) => ({
    value: option._id,
    label: option.nom + " " + option.prenom,
  }));

  const [selectMode, setSelectMode] = useState<boolean>(false);
  const [refundedOrders, setRefundedOrders] = useState<OrderType[]>([]);
  const [selectedOrders, setSelectedOrders] = useState<OrderType[]>([]);

  const [selectionRefundOnly, setSelectingRefundOnly] = useState(false);

  const handleSelectToggle = () => {
    setSelectMode((prev) => !prev);
    setSelectedOrders([]); // Reset selection when exiting select mode
  };
  const selectAll = () => {
    setSelectedOrders(Orders);
  };

  const handleOrderSelect = (orderId: string, orders: OrderType[]) => {
    if (selectionRefundOnly) {
      setRefundedOrders((prev) => {
        const isSelected = prev.some((order) => order._id === orderId);

        if (isSelected) {
          return prev.filter((order) => order._id !== orderId);
        } else {
          const selectedOrder = orders.find((order) => order._id === orderId);
          return selectedOrder ? [...prev, selectedOrder] : prev;
        }
      });
    } else {
      setSelectedOrders((prev) => {
        const isSelected = prev.some((order) => order._id === orderId);

        if (isSelected) {
          return prev.filter((order) => order._id !== orderId);
        } else {
          const selectedOrder = orders.find((order) => order._id === orderId);
          return selectedOrder ? [...prev, selectedOrder] : prev;
        }
      });
    }
  };

  const [selectedDeliveryCompany, setSelectedDeliveryCompany] =
    useState<string>("");

  const saveStatusChange = async (
    orders: OrderType[],
    choosenStatus: string,
  ) => {
    // If status is "en livraison", first show delivery company selection modal
    if (choosenStatus === "En livraison") {
      // You can create a custom modal component or use Swal with state
      let freeDelivery = false;
      const { value: deliveryCompanyId } = await Swal.fire({
        title: "Sélectionnez la société de livraison",
        html: `<div class="form-check form-switch d-flex justify-content-center gap-2">
            <input class="form-check-input" type="checkbox" id="free-delivery-switch" />
            <label class="form-check-label" for="free-delivery-switch">Livraison gratuite</label>
          </div>`,
        preConfirm: (value) => {
          freeDelivery = !!(
            Swal.getPopup()?.querySelector(
              "#free-delivery-switch",
            ) as HTMLInputElement
          )?.checked;
          return value;
        },
        input: "select",
        inputOptions: delivery_companies.reduce(
          (options: any, company: any) => {
            options[company._id] = company.libelle;
            return options;
          },
          {} as Record<string, string>,
        ),
        inputPlaceholder: "Choisir une société",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Veuillez sélectionner une société de livraison";
          }
        },
      });

      if (deliveryCompanyId) {
        const selectedCompany = delivery_companies.find(
          (c: any) => c._id === deliveryCompanyId,
        );

        // Free delivery: fees are not charged and won't appear on the invoice
        const deliveryFees = !freeDelivery;
        const societeLivraison = deliveryFees
          ? selectedCompany
          : { ...selectedCompany, frais_livraison: 0 };

        // Now confirm the status change
        Swal.fire({
          title: "Voulez-vous confirmer le changement de statut ?",
          text: `Société de livraison: ${selectedCompany?.libelle} - ${
            deliveryFees ? "frais de livraison inclus" : "livraison gratuite"
          }`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        }).then(async (result) => {
          if (result.isConfirmed) {
            // 1. Map to an array of promises
            const updatePromises = orders.map((item) =>
              dispatch(
                updateOrderApi({
                  orderId: item._id,
                  status: choosenStatus,
                  paidProducts: [],
                  vendeur: null,
                  societe_livraison: societeLivraison,
                  deliveryFees,
                }),
              ),
            );

            // 2. Wait for all updates to complete
            await Promise.all(updatePromises);
            window.location.reload();
            // 3. Refresh your data (Call your fetch function here)
            // await dispatch(fetchOrders());

            setSelectMode(false);

            Swal.fire(
              "Mis à jour !",
              "Les statuts ont été modifiés.",
              "success",
            );
          }
        });
      }
    } else {
      // Original logic for other statuses
      Swal.fire({
        title: "Voulez-vous confirmer ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.isConfirmed) {
          orders.map(async (item) => {
            const res = await dispatch(
              updateOrderApi({
                orderId: item._id,
                status: choosenStatus,
                paidProducts: [],
                vendeur: null,
              }),
            );
            if (res.payload.success) {
              setSelectMode(false);
            }
          });
        }
      });
    }
  };
  const lastKeyPressTime = useRef<number>(0);

  const handleChange = (e: any) => {
    const { value } = e.target;
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        getListOrder(value);
      },
      isScannerInput ? 100 : 2000,
    );
  };
  useEffect(() => {
    // Ajout de l'écouteur lors du montage
    const handleKeyPress = (e: any) => {
      const currentElement = document.activeElement;
      // Si l'élément actif n'est pas un champ input,
      // alors on redirige le focus vers l'input "code_input"
      if (currentElement && currentElement.tagName.toLowerCase() !== "input") {
        const myInputElement = document.getElementById("code_input");
        if (myInputElement) {
          myInputElement.focus();
        }
      }
    };

    document.addEventListener("keypress", handleKeyPress);
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);
  const getSpecialProcessTicket = (tickets: TicketType[], order: OrderType) => {
    const hasEchange = tickets.some((ticket) => ticket.process === "Echange");
    const hasRetour = false;

    if (hasEchange && hasRetour) {
      return "Echange&Retour"; // Both exist
    } else if (hasEchange) {
      return "Echange"; // Only Echange exists
    } else if (hasRetour) {
      return "Retour"; // Only Retour exists
    } else {
      return null; // No special process tickets
    }
  };
  const TypeInputParametrage = parametrage?.SearchCaisse;

  const [TypeInput, setTypeInput] = useState(TypeInputParametrage);
  const [ListReference, setListReference] = useState<any[]>();
  const [ShowModalListReference, setShowModalListReference] = useState(false);
  const [ReferenceArticle, setReferenceArticle] = useState<any>();
  useEffect(() => {
    if (ReferenceArticle) {
      const newFiltre = {
        ...filtre,
        reference: ReferenceArticle?.article?._id,
      };

      // Update state immediately
      setFiltre(newFiltre);

      // Then dispatch with the updated filtre
      dispatch(findOrdersFiltreApi(newFiltre));
    }
  }, [ReferenceArticle]);

  const handleBarcodeChange = (e: any) => {
    const { value } = e.target;
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        setFiltre((prev) => ({
          ...prev,
          barCode: value,
          reference: "", // Clear reference when searching by barcode
        }));
        // Dispatch the search with updated filtre
        dispatch(
          findOrdersFiltreApi({
            ...filtre,
            barCode: value,
            reference: "",
          }),
        );
      },
      isScannerInput ? 100 : 2000,
    );
  };
  const handleInputChange = async (inputValue: any) => {
    const resultReference = await dispatch(
      findArticleRefParentApi({ ref: inputValue, societe_id: societe_id }),
    );

    // const resultBon = await dispatch(findBonByBarcode(inputValue));
    if (resultReference.payload) {
      const list = resultReference?.payload?.map((e: any) => {
        return { article: e };
      });
      setListReference(list);
      setShowModalListReference(true);
    }
    setTypeInput(TypeInputParametrage);
  };
  return (
    <>
      <div className="row layout-spacing">
        <div className=" row statbox widget box box-shadow">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="col-9">
              {" "}
              <h3>{t("Liste des commandes")}</h3>
            </div>
          </div>
          <div className="row">
            <div className="search-bar col-6" style={{ position: "relative" }}>
              {" "}
              <input
                autoFocus
                style={{
                  background: "#f1f2f3",
                  border: "none",
                  paddingRight: "70px", // add space for the button
                }}
                type="text"
                id="code_input"
                className="form-control"
                placeholder={t("scan ticket")}
                onChange={handleChange}
              />
            </div>
            <div className="search-bar col-6" style={{ position: "relative" }}>
              <input
                autoFocus
                style={{
                  background: "#f1f2f3",
                  border: "none",
                  paddingRight: "70px", // add space for the button
                }}
                type="text"
                id="code_input"
                className="form-control"
                placeholder={t("scan article")}
                onChange={(e) => {
                  if (TypeInput === "codeBarre") {
                    handleBarcodeChange(e);
                  } else {
                    handleInputChange(e.target.value);
                    // handleReferenceChange(e);
                  }
                }}
              />
              <button
                className="btn btn-primary"
                onClick={() =>
                  setTypeInput(TypeInput === "codeBarre" ? "ref" : "codeBarre")
                }
                style={{
                  position: "absolute",
                  right: "18px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: "4px 10px",
                }}
              >
                {TypeInput === "codeBarre" ? "CB" : "REF"}
              </button>
            </div>
          </div>
          <div className="row mt-3 mb-3 orders-filter">
            <div className=" col-lg-2 col-sm-6  col-md-6">
              <div className="search-bar">
                <input
                  style={{ background: "#f1f2f3", border: "none" }}
                  type="text"
                  className="form-control "
                  placeholder={t("search")}
                  value={filtre.numOrder}
                  onChange={(e) =>
                    setFiltre((prev) => ({
                      ...prev,
                      numOrder: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <input
              type="Date"
              className="form-control col-lg-2  col-sm-6  col-md-6"
              style={{
                background: "#f1f2f3",
                border: "none",
                width: "auto",
                height: "auto",
              }}
              id="datepicker"
              value={filtre.dateDebut}
              onChange={(e) =>
                setFiltre((prev) => ({
                  ...prev,
                  dateDebut: e.target.value,
                }))
              }
            />{" "}
            <input
              type="Date"
              className="form-control col-lg-2  col-sm-6  col-md-6"
              style={{
                background: "#f1f2f3",
                border: "none",
                width: "auto",
                height: "auto",
              }}
              id="datepicker"
              value={filtre.dateFin}
              onChange={(e) =>
                setFiltre((prev) => ({
                  ...prev,
                  dateFin: e.target.value,
                }))
              }
            />{" "}
            <Select
              isMulti
              options={UsersOptions}
              isSearchable={true}
              placeholder="caissiers"
              className="col-lg-2    col-sm-3"
              onChange={(newSelectedOptions) =>
                handleSelectChangeUsers(newSelectedOptions)
              }
            />
            <div
              className=" col-lg-2  col-sm-6  col-md-6 "
              onClick={open}
              style={{ display: "flex", justifyContent: "right" }}
            >
              <div
                className={"dropdown custom-dropdown-icon " + show}
                style={{ cursor: "pointer" }}
              >
                <a
                  className="dropdown-toggle btn"
                  href="#"
                  role="button"
                  id="customDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={stateShow}
                >
                  <span> {t(filtre.status)} </span>{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div
                  className={"dropdown-menu dropdown-menu-right " + show}
                  aria-labelledby="customDropdown"
                >
                  {statusList?.map(({ status, label }, index) => (
                    <div
                      key={index}
                      className="dropdown-item"
                      data-value={label} // If needed for tracking
                      onClick={() =>
                        setFiltre((prev) => ({
                          ...prev,
                          status: status,
                        }))
                      }
                    >
                      {t(label)} {/* Assuming t is for translation */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <span className="col-lg-1 " onClick={() => getListOrder("")}>
              <i style={{ fontSize: "20px" }} className=" fas fa-search"></i>
            </span>
          </div>
          <div className="row action-bar">
            {user && user.role_id?.libelle === "onlineSale" && (
              <div className="col-12 action-buttons">
                {selectMode && (
                  <button
                    className="btn action-btn primary"
                    onClick={selectAll}
                  >
                    Sélectionner tous
                  </button>
                )}

                <button
                  className={`btn action-btn ${
                    selectMode ? "danger" : "primary"
                  }`}
                  onClick={handleSelectToggle}
                >
                  {selectMode ? "Annuler" : "Sélectionner"}
                </button>
              </div>
            )}
          </div>

          {user &&
          user.role_id?.libelle === "onlineSale" &&
          selectedOrders?.length &&
          selectMode ? (
            <div className="row bulk-actions">
              <div className="col-12 bulk-title">Statut commande</div>

              {!Orders?.some((item) => item.status === "Pre-confirmée") && (
                <>
                  <div className="col bulk-col">
                    <button
                      className="btn btn-primary"
                      disabled={
                        !selectedOrders.every(
                          (order) => order.status === "Nouvelle",
                        )
                      }
                      onClick={() =>
                        saveStatusChange(selectedOrders, "En livraison")
                      }
                    >
                      En livraison
                    </button>
                  </div>

                  <div className="col bulk-col">
                    <button
                      className="btn btn-danger"
                      onClick={() => saveStatusChange(selectedOrders, "Retour")}
                    >
                      Retour
                    </button>
                  </div>

                  <div className="col bulk-col">
                    <button
                      className="btn btn-success"
                      onClick={handleSelectMultipleOrders}
                      disabled={
                        !selectedOrders.every(
                          (order, _, arr) =>
                            order.societe_livraison?._id ===
                            arr[0].societe_livraison?._id,
                        )
                      }
                    >
                      Payer
                    </button>
                  </div>
                </>
              )}

              <div className="col bulk-col">
                <button
                  className="btn btn-danger outline"
                  onClick={() => saveStatusChange(selectedOrders, "Annulée")}
                >
                  Annulée
                </button>
              </div>
            </div>
          ) : null}

          <div
            className="widget-content widget-content-area"
            style={{ overflowX: "auto" }}
          >
            {/* <p style={{ float: "right" }}>Total Net : {totalNet?.toFixed(3)}</p> */}

            <table id="style-2" className="table style-2  table-hover">
              <thead>
                <tr>
                  <th
                    className="checkbox-column dt-no-sorting"
                    style={{ fontSize: "15px" }}
                    onClick={() => console.log(Orders)}
                  >
                    {t("N° commande")}
                  </th>
                  <th style={{ fontSize: "15px" }}>{t("Date")}</th>
                  {selectedOrganisation &&
                    selectedOrganisation?.Type?.table && (
                      <th style={{ fontSize: "15px" }}>{t("Table")}</th>
                    )}
                  <th style={{ fontSize: "15px" }}>{t("client")}</th>
                  <th className="text-center" style={{ fontSize: "15px" }}>
                    {t("Operation")}
                  </th>
                  <th className="text-center" style={{ fontSize: "15px" }}>
                    {t("status")}
                  </th>
                  <th className="text-center" style={{ fontSize: "15px" }}>
                    {t("facture")}
                  </th>
                </tr>
              </thead>
              {loader ? (
                <Spinner />
              ) : (
                <tbody>
                  {Orders && Orders?.length > 0 && (
                    <>
                      {[...Orders].reverse().map((item) => {
                        // Check if the item has a ticket with 'echange' or 'retour' process
                        const specialProcess = getSpecialProcessTicket(
                          item.tickets || [],
                          item,
                        );

                        return (
                          <tr key={item._id}>
                            <td
                              className="checkbox-column"
                              style={{ fontSize: "15px", position: "relative" }}
                            >
                              {selectMode && (
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedOrders.includes(item) ||
                                    refundedOrders.includes(item)
                                  }
                                  onChange={() =>
                                    handleOrderSelect(item._id, Orders)
                                  }
                                  style={{ marginRight: "5px" }}
                                />
                              )}
                              <a
                                className="link"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handleSelectOrder(item)}
                              >
                                {item.order_number}
                                {/* Render badge in the top-right corner of the table cell */}
                                {specialProcess && (
                                  <span
                                    className="shadow-none badge badge-warning"
                                    style={{
                                      position: "absolute", // Position relative to the <td> (now it's the parent)
                                      top: "5px", // Adjust to move it down slightly
                                      right: "5px", // Move it to the right side
                                      padding: "2px 6px",
                                      fontSize: "12px",
                                      borderRadius: "4px",
                                      backgroundColor: "#f39c12", // Customize the badge color
                                      color: "white",
                                    }}
                                  >
                                    {specialProcess}
                                  </span>
                                )}
                                {item?.tickets?.some(
                                  (ticket) =>
                                    ticket.process === "Echange" &&
                                    ticket.returnedArticlesToStock === false,
                                ) && (
                                  <span
                                    className="shadow-none badge badge-danger"
                                    style={{
                                      position: "absolute",
                                      top: "22px",
                                      right: "5px",
                                      padding: "2px 6px",
                                      fontSize: "12px",
                                      borderRadius: "4px",
                                      color: "white",
                                    }}
                                  >
                                    {"pas de retour"}
                                  </span>
                                )}
                              </a>
                            </td>

                            <td style={{ fontSize: "15px" }}>
                              {formatDateAndTime(item.date)}
                            </td>
                            {selectedOrganisation?.Type?.table && (
                              <td style={{ fontSize: "15px" }}>
                                {item.table_id?.numero || 1}
                              </td>
                            )}
                            <td style={{ fontSize: "15px" }}>
                              {item.client_id?.nom}
                            </td>
                            <td
                              className="text-center"
                              style={{ fontSize: "15px" }}
                            >
                              <span
                                className={
                                  item.identityTicket?.process === "Echange"
                                    ? "shadow-none badge badge-warning"
                                    : item.status === "Avoir"
                                    ? "shadow-none badge badge-danger"
                                    : item.status === "Retour"
                                    ? "shadow-none badge badge-danger"
                                    : "shadow-none badge badge-success"
                                }
                                style={{
                                  width: "100%",
                                  height: "25px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "15px",
                                  cursor: "pointer",
                                }}
                                onClick={() => console.log(item)}
                              >
                                {t(
                                  item.identityTicket?.process === "Echange"
                                    ? "Echange"
                                    : item.status === "Avoir"
                                    ? "Avoir"
                                    : item.status === "Retour"
                                    ? "Retour"
                                    : "Vente",
                                )}{" "}
                              </span>
                            </td>
                            <td
                              className="text-center"
                              style={{ fontSize: "15px" }}
                            >
                              <span
                                className={
                                  item.status === "Nouvelle"
                                    ? "shadow-none badge badge-info"
                                    : item.status === "En attente" ||
                                      item.status === "En cours"
                                    ? "shadow-none badge badge-warning"
                                    : item.status === "Payée"
                                    ? "shadow-none badge badge-success"
                                    : item.status === "Partiellement payée"
                                    ? "shadow-none badge badge-danger"
                                    : item.status === "En livraison"
                                    ? "shadow-none badge badge-primary"
                                    : "shadow-none badge badge-danger"
                                }
                                style={{
                                  width: "100%",
                                  height: "25px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "15px",
                                  cursor: "pointer",
                                }}
                                onClick={() => console.log(item)}
                              >
                                {t(item.status)}
                              </span>
                            </td>
                            <td
                              style={{ textAlign: "center", display: "grid" }}
                            >
                              {/* {isOnlineSale ? (
                                item.status !== "Pre-confirmée" &&
                                item.tickets
                                  ?.filter(
                                    (ticket) =>
                                      ticket.process === "Echange" ||
                                      ticket.process === "Online"
                                  )
                                  .map((ticket, index) => (
                                    <a
                                      onClick={() => {
                                        ticket &&
                                          ticket._id &&
                                          handleOpenTicket(
                                            item._id,
                                            ticket?._id
                                          );
                                      }}
                                      key={index}
                                      className="link"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {"facture "}{" "}
                                      {ticket.process === "Online"
                                        ? "Vente"
                                        : ticket.process}
                                    </a>
                                  ))
                              ) : ( */}
                              <a
                                className="link"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleOpenTicket(item._id, null)}
                              >
                                {"facture"}
                              </a>
                              {/* )} */}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  )}
                </tbody>
              )}
            </table>
          </div>
          <PaginationLayout
            index={index}
            nbrpage={currentpage}
            totalpages={totalPages}
            setindex={setindex}
          />
        </div>
      </div>
      <ArticleListReference
        t={t}
        ShowModal={ShowModalListReference}
        setShowModal={setShowModalListReference}
        selectAricle={setReferenceArticle}
        list={ListReference}
        reference={""}
      />
      {ticketId ? (
        <>
          <TicketAvance
            ShowModal={showModalTicketAvance}
            setShowModal={setShowModalTicketAvance}
            ticket={ticketId}
            reservation={Reservation}
          />
        </>
      ) : null}
      <OnlineOrderInvoice
        order_id={orderId}
        ticket={ticket}
        show={facture}
        setShow={setFacture}
        onClose={handleCloseModal} // Pass the close handler to reset the state
      />
      <OrderStatusPopUp
        show={showStatusModal}
        order={selectedOrder}
        onClose={() => setShowStatusModal(false)}
        selectedStatus={selectedOrder.status}
        onChangeStatus={handleStatusChange}
      />
    </>
  );
};

export default OrdersListOnline;
